<template>
  <div>
    <section class="mb-4 sm:mb-8 lg:mb-10">
      <div class="container z-grid v-page-section-container-padding">
        <div class="col-span-full 2xl:col-start-2 2xl:col-end-12 sm:flex flex-row items-center justify-between leading-none mb-4 sm:mb-6">
          <h2 class="flex-auto text-xl sm:text-2xl lg:text-3xl font-semibold text-app-primary-1-red--fire-brick" :class="{ 'mb-2 sm:mb-0': true }">
            {{ $t('home-discovery-title') }}
          </h2>
          <MoleculeButton :url="globalStore.discoveryOverview.url" :enable-icon-left="false" size="small" class="md:hidden">
            {{ $t('home-discovery-button') }}
          </MoleculeButton>
          <MoleculeButton :url="globalStore.discoveryOverview.url" :enable-icon-left="false" size="large" class="hidden md:block">
            {{ $t('home-discovery-button') }}
          </MoleculeButton>
        </div>
      </div>
      <div :class="{ 'pb-4 sm:pb-6 border-b border-app-primary-grey--black-squeeze': true }">
        <MoleculeDiscoveryCarousel :items="discoveries" :slides-visible="3" />
      </div>
    </section>

    <section v-if="discoveryCollections.length" class="container z-grid mx-auto v-page-section-container-padding">
      <MoleculeShelf :title="$t('home-discovery-collections-title')" :has-border="false" class="col-span-full 2xl:col-start-2 2xl:col-end-12">
        <div class="grid grid-cols-12 gap-4 sm:gap-5 lg:gap-8">
          <MoleculeCardCollection
            v-for="(entry, index) in discoveryCollections.slice(0, 4)"
            :key="index"
            class="col-span-6"
            :title="entry.title"
            :image="entry.image"
            :url="entry.url"
            :button-text="$t('discovery-shelf-collection-label')"
          />
        </div>
      </MoleculeShelf>
    </section>
  </div>
</template>

<script setup lang="ts">
defineProps({
  discoveries: { type: Array as PropType<any[]>, required: true },
  discoveryCollections: { type: Array as PropType<any[]>, required: true },
})

const globalStore = useGlobalStore()
</script>
